<h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>preview</mat-icon>
    </span>
    Document Preview
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <!-- <embed class="openpdf" src="../../../../assets/Residential_Lease.pdf"> -->
        <div class="docWrapper">
            <div class="docCont">
             
            <div class="docSign" id="docSign" #content>
              <div class=docHolding *ngFor="let item of particiantJsonList;let i= index;" id=docHolding{{i+1}}>
        
                <!-- <button class="next" mat-flat-button (click)="movetoNextControl()" >Next</button> -->
                <!-- <app-canvas [height]="setHeight(i)" [canvasIndex]="i" (newItemEvent)="setIndex($event)" *ngIf="isDrawing"></app-canvas> -->
               
                <ng-container *ngFor="let field of item.fields">
                   
                    <ng-container  *ngIf="field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
                    && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">            
                     <div  class="iframe-resize-container"
                       [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"                
                       [ngStyle]="{'position': 'absolute','width': field.offsetWidth+'px','height': field.offsetHeight+'px','transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}"        
                       [ngClass]="{'ng-show-required' : field.showRequiredControls}"   (click)="verifyParticipant(field,$event)"
                       
                       >
                       <div class="iframe-drag-handle" 
                           (click)="addActiveClass(field)"
                            [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}"
                            [attr.field]="field.id" 
                              #dragHandle >
                      
                              <ng-container *ngIf="field.fieldTypeName=='Dropdown'">
                                <mat-select  id="{{field.id}}" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                                ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + field.colorCode + ')'}"
                                
                                (click)="OpentoolDetail('Dropdown')"
                                (click)="OpentoolDetailDropDown(item,field.id)"
                                (selectionChange)="setDdlValue($event,item,field.id)" 
                                  [ngModel]="field.selectedValue"
                                  [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                  >
                                  <mat-option [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'field-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                                  ,'height': field.offsetHeight+'px'}"
                                   *ngFor="let drp of field.fillList" [value]="drp.val">
                                    {{ drp.val }}
                                  </mat-option>
                                </mat-select>            
                              </ng-container>
        
                              
        
                              <ng-container *ngIf="field.fieldTypeName=='Number'">
                                <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                                 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                                ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px','border': '2px solid rgb(' + field.colorCode + ')','transform':'rotate('+field.rotation+'deg)'}"  placeholder="{{field.fieldName}}"              
                                [(ngModel)]='field.selectedValue' type="text" class="form-control"  id="{{field.id}}"
                                (input)="onChange($event.target.value,item,field.id)" (click)="OpentoolDetail('Number')"
                                (keypress)="numberOnly($event)"  id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)"
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                >
                              </ng-container>
        
                              
        
                              <ng-container *ngIf="field.fieldTypeName=='Textbox'">
                                <input   
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                               ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + field.colorCode + ')'}"  
                                (input)="onChange($event.target.value,item,field.id)" 
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                                placeholder="{{field.fieldName}}" (click)="OpentoolDetail('Textbox')"
                                (click)="OpentoolDetailText(item,field.id)">
                              </ng-container> 
        
                              <ng-container *ngIf="field.fieldTypeName=='Textarea'">
                                <textarea [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                               ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + field.colorCode + ')'}"  
                                 [innerHtml]='field.selectedValue' (input)="onChange($event.target.value,item,field.id)"
                                 (click)="OpentoolDetail('Textarea')" class="form-control"  id="{{field.id}}" placeholder="{{field.fieldName}}"
                                 [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                 (click)="OpentoolDetailText(item,field.id)"></textarea>
                              </ng-container>
                
                              <ng-container *ngIf="field.fieldTypeName=='Currency'">
                                <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily
                                 ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"  
                                 type="text" [(ngModel)]='field.selectedValue' (input)="onChange($event.target.value,item,field.id)" 
                                  class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}"
                                 (click)="OpentoolDetail('Number')"
                                 (click)="OpentoolDetailText(item,field.id)">
                              </ng-container>
                
                              <ng-container *ngIf="field.fieldTypeName=='URL'">
                                <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                                type="text" [value]='field.selectedValue' 
                                (input)="onChange($event.target.value,item,field.id)" 
                                (click)="OpentoolDetail('URL')"
                                (click)="OpentoolDetailText(item,field.id)"
                                class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}">
                              </ng-container> 
                             
                              <ng-container *ngIf="field.fieldTypeName=='MultiSelect'">
                                <mat-select  id="{{field.id}}" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                color="primary" [ngModel]="field.selectedValue" 
                                (selectionChange)="setDdlValue($event,item,field.id)"
                                (click)="OpentoolDetail('MultiSelect')"
                                (click)="OpentoolDetailMulDropDown(item,field.id)"                
                                 [required]='field.isRequired' multiple>
                                <mat-option *ngFor="let muldrp of field.fillList" [value]="muldrp.val">
                                  {{ muldrp.val }}
                                </mat-option>
                              </mat-select>                 
                              </ng-container>
                
                              <ng-container *ngIf="field.fieldTypeName=='Address'">
                                <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                                 type="text" class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}">
                              </ng-container>
                
                              <ng-container *ngIf="field.fieldTypeName=='Location'">
                                   
                                <div  id="{{field.id}}" class="customUpdate"
                                (click)="OpentoolDetail('Location')" (click)="fetchLocation(item,field.id)"
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                >
                                  <span *ngIf='!field.Lat && !field.Long'>
                                    <mat-icon>location_on</mat-icon>
                                    Location
                                  </span>
                                  <ng-container  *ngIf='field.Lat && field.Long'>
                                  <h3 [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  > 
                                    Lat : {{field.Lat}}
                                    Long: {{field.Long}}
                                  </h3>
                                 </ng-container>
                                              
                                </div>                   
                               </ng-container>  
                
                               <ng-container *ngIf="field.fieldTypeName=='Date'">
                                 <div class="Dtime"
                                 [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                 [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                 >
                                  <input  id="{{field.id}}" matInput type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                                 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                                 [ngModel]="field.selectedValue |date:'yyyy-MM-dd'" placeholder='Date'
                                 
                                  (input)="onChange($event.target.value,item,field.id)"
                                 (dateChange)="onChange($event.target.value,item,field.id)"
                                 (click)="OpentoolDetail('Date')"
                                 (click)="OpentoolDetailText(item,field.id)"  
                                 [matDatepicker]="basicDatepicker"
                                 
                                 />
                               <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                               <mat-datepicker #basicDatepicker ></mat-datepicker>     
                                 </div>
                                             
                               </ng-container>
                               
                               <ng-container *ngIf="field.fieldTypeName=='Time'">
                                <div class="Dtime"                        
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                >
                                  <input   
                                  id="{{field.id}}"
                                   type="text"
                                     [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                aria-label="default time"
                                 [ngxTimepicker]="toggleTimepicker"
                                  (click)="OpentoolDetail('Time')" 
                                (click)="OpentoolDetailText(item,field.id)" matInput  placeholder='Time' [(ngModel)]='field.selectedValue' readonly>
                                <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                                <ngx-material-timepicker (timeSet)="onChange($event,item,field.id)"  #toggleTimepicker>
                                </ngx-material-timepicker>
                                </div>
                               </ng-container>
                
                              
                               <ng-container *ngIf="field.fieldTypeName=='File'">
                                <div class="customUpdate" (click)="OpentoolDetail('File')"  id="{{field.id}}"
                                (click)="OpentoolDetailText(item,field.id)"
                                [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                >
                                  <span *ngIf='field.FileData.length==0'>
                                    <mat-icon>cloud_upload</mat-icon>
                                    Upload File
                                  </span>                    
                
                                  <div *ngFor="let file of field.FileData" class="uploadedData">
                
                                    <p>{{file.FullPath}}</p>
        
                                  
                
                                </div>
                                 <input type="file" class="form-control" id="{{field.fieldName}}" 
                                 (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                                </div>
                              </ng-container>                  
                
                
                
                              <ng-container *ngIf="field.fieldTypeName=='Signature'">
                                <div  id="{{field.id}}" class="customUpdate" 
                                [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                (click)="OpentoolDetail('Signature')" >
                                  <span *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                                    <mat-icon>border_color</mat-icon>
                                    Signature
                                  </span>
                                  <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                                 
                                  <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                                  <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                                 </ng-container>
                                  <div *ngFor="let img of field.ImageData" class="uploadedData">
                                    <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                                 </div>                
                                </div>                   
                               </ng-container>  
                               
                               <ng-container *ngIf="field.fieldTypeName=='Draw'">
                                <div  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')" 
                                
                                [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                >
                                  <span *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                                    <mat-icon>brush</mat-icon>
                                    Draw
                                  </span>                                  
                                  <img *ngIf='field.drawBase64' [src]="field.drawBase64"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                                </div>                   
                               </ng-container>  
                
                               <ng-container *ngIf="field.fieldTypeName=='Drawpopup'">
                                <div  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')" >
                                  <span *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                                    <mat-icon>brush</mat-icon>
                                    Draw
                                  </span>                                  
                                  <img *ngIf='field.drawBase64' [src]="field.drawBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                                </div>                   
                               </ng-container>
                             
                               <ng-container *ngIf="field.fieldTypeName=='Initials'">
                                <div  id="{{field.id}}" class="customUpdate" 
                                [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                                [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                (click)="OpentoolDetail('Initials')">
                                  <span *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                                   <mat-icon>gesture</mat-icon>
                                    Initials
                                  </span>
                                  <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                                  <ng-container  *ngIf='field.signatureText && !field.signatureBase64' >
                                    <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                                  </ng-container>
                                  <div *ngFor="let img of field.ImageData" class="uploadedData">
                                    
                                    <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                                 </div>                
                                </div>                   
                               </ng-container>  
                
                               <ng-container *ngIf="field.fieldTypeName=='BulletList'">
                                 <label  id="{{field.id}}" class="bullet"  (click)="OpentoolDetail('BulletList')"
                                  (click)="OpentoolDetailBulletList(item,field.id)">
                                   <ul (click)="OpentoolDetailBulletList(item,field.id)">
                                     <li [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                     *ngFor="let bu of field.fillList">{{bu.val}}</li>
                                   </ul>
                                 </label>
                               </ng-container>
                               
                               <ng-container *ngIf="field.fieldTypeName=='Button'">
                                <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                type="submit" [value]='field.buttonName' class="btn-primary btnGlobal"  id="{{field.id}}"
                                (click)="OpentoolDetail('Button')" 
                                (click)="OpentoolDetailText(item,field.id)">
                               </ng-container>
                
                               <ng-container *ngIf="field.fieldTypeName=='ApproveOrDecline'">
                                <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                *ngIf="field.buttonText=='Approve'" type="submit" [value]="field.buttonText" class="btn-success btnAccept"  id="{{field.id}}"
                                (click)="OpentoolDetail('ApproveOrDecline')" (click)="OpentoolDetailText(item,field.id)">
                                <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                *ngIf="field.buttonText=='Decline'" type="submit" [value]="field.buttonText" class="btn-success btnDecline"  id="{{field.id}}"
                                (click)="OpentoolDetail('ApproveOrDecline')" (click)="OpentoolDetailText(item,field.id)">
                               </ng-container>
                
                               <ng-container *ngIf="field.fieldTypeName=='Table'">
                                 <table  id="{{field.id}}" class="formTable" border="1px" (click)="OpentoolDetail('Table')"
                                 (click)="OpentoolDetailText(item,field.id)">                   
                                  <tbody (click)="OpentoolDetailtbl(item,field.id)">    
                                  <tr *ngFor = "let row of field.rows;let r=index">
                                    <td *ngFor = "let column of field.column;let c=index">
                                      <input readonly id='txt-{{r+1}}{{c+1}}' [ngModel]="getColumnValue(item,field.id,r+1,c+1)" (input)="onTableChange($event,item,field.id)"  type="text"/>
                                    </td>
                                   </tr>
                                    </tbody>
                                  </table>                 
                               </ng-container>
                
                               <ng-container *ngIf="field.fieldTypeName=='StrikeThrough'">
                                <div  id="{{field.id}}" style="border-top: 1px solid black; width: 100%;height: 20px; margin-top:18px"
                                (click)="OpentoolDetail('StrikeThrough')"
                                (click)="OpentoolDetailText(item,field.id)"></div>                  
                               </ng-container>
                
                               <ng-container *ngIf="field.fieldTypeName=='WhiteOut'">
                                <div  id="{{field.id}}" style="background-color: white; width: 100%;height: 100%;"
                                 (click)="OpentoolDetail('WhiteOut')"
                                 (click)="OpentoolDetailText(item,field.id)"></div>                  
                               </ng-container>
                
                               <ng-container *ngIf="field.fieldTypeName=='HighLight'">
                                  <div style=" width: 100%;height: 100%;"  id="{{field.id}}"
                                  [ngStyle]="{'background-color': 'rgba(' + field.backgroundColor + ')'}"
                                   (click)="OpentoolDetail('HighLight')"
                                   (click)="OpentoolDetailText(item,field.id)"></div>                  
                               </ng-container>
                
                                <ng-container *ngIf="field.fieldTypeName=='StraightLine'">
                                    <div  id="{{field.id}}" style="border-bottom: 1px solid black; width: 100%;height: 20px; margin-top:0px"
                                    (click)="OpentoolDetail('line')"
                                    (click)="OpentoolDetailText(item,field.id)"></div>                  
                                </ng-container>
                              
                                <ng-container *ngIf="field.fieldTypeName=='measure'">
                                  <div  id="{{field.id}}" style="border-bottom: 1px solid black; width: 100%; margin:0px"
                                  (click)="OpentoolDetail('measure')"
                                  (click)="OpentoolDetailText(item,field.id)">
                                   {{field?.width}}
                                </div>                  
                                </ng-container>
                
                     </div>
                   </div>
                 </ng-container>
        
                 <ng-container  *ngIf="field.fieldTypeName=='Checkbox' || field.fieldTypeName=='Radio' ||
                 field.fieldTypeName=='CheckBoxGroup'">
                  <div class="radioHolder"  id="{{field.id}}">
                    <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
                    [ngStyle]="{'position': 'absolute','transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}" 
                    [ngClass]="{'ng-show-required' : field.showRequiredControls}"
                    (click)="verifyParticipant(field,$event)"
                   
                    >
                    <div class="iframe-drag-handle"  [attr.field]="field.id"  (click)="addActiveClass(field)"
                    [ngStyle]="{'border-color': 'rgba(' + field.colorCode + ')'}"
                    #dragHandle>
                    <ng-container *ngIf="field.fieldTypeName=='Checkbox'">
                      <label 
                      [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                      }"
                       class="checkboxfield" (click)="OpentoolDetail('Checkbox')"
                      (click)="OpentoolDetailCheckBox(item,field.id,ele.id)">                
                          <input type="checkbox" class="mat-checkbox-input" [attr.checked]='ifChkChecked(field.id,item,ele.id)'  [checked]='ifChkChecked(field.id,item,ele.id)'
                            (click)="OnChangeCheckBox($event, ele.val, field.id,item,ele.id)">
                           {{ele.val}}               
                      </label>
                    </ng-container>
        
                    <ng-container *ngIf="field.fieldTypeName=='Radio'">
                     <div class="flexCol"  id="{{field.id}}"> 
                       <label  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       }"
                       class="radiofield" (click)="OpentoolDetail('Radio')"
                       (click)="OpentoolDetailRadioButtonGroup(item,field.id,ele.id)">                
                         <input type="radio" class="mat-checkbox-input" [attr.checked]='ifChkChecked(field.id,item,ele.id)' name='{{field.id}}' [checked]='ifRadioChecked(field.id,item,ele.id)' (change)="OnChangeRadio($event, ele.val, field.id,item,ele.id)" >
                         {{ele.val}}
                       </label>                  
                       <!-- <span class="addChRad" *ngIf="field.fillList.length==(i+1)"><mat-icon (click)="AddControlRadioButon(field.id,item)">add</mat-icon></span> -->
                     </div>
                    </ng-container>
        
                    <ng-container *ngIf="field.fieldTypeName=='CheckBoxGroup'">
                      <div class="flexCol"  id="{{field.id}}">
                       <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                       class="checkboxfield" (click)="OpentoolDetail('CheckBoxGroup')"
                       (click)="OpentoolDetailCheckBoxGroup(item,field.id,ele.id)">                   
                        
                         <input class="mat-checkbox-input" type="checkbox" [attr.checked]='ifChkChecked(field.id,item,ele.id)' [checked]='ifChkChecked(field.id,item,ele.id)' (change)="OnChangeCheckBoxGroup($event, ele.val, field.id,item,ele.id)">
                         {{ele.val}}
                       </label> 
                       <!-- <span class="addChRad" *ngIf="field.fillList.length==(i+1)"><mat-icon (click)="AddControlCheckBoxGroup(field.id,item)">add</mat-icon></span> -->
                      </div>
                    </ng-container>
        
                  </div>
                </div>
                </div>
              </ng-container>
        
        
              <ng-container  *ngIf="field.fieldTypeName=='Image'">
                <div class="radioHolder"  id="{{field.id}}">
                  <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
                  [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}" 
                   [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth,'transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}" 
                  style="position: absolute"  
                   (click)="verifyParticipant(field,$event)"
                 
                  >
                  <div class="iframe-drag-handle" (click)="addActiveClass(field)"  [attr.field]="field.id" 
                  
                  #dragHandle>
         
                  <ng-container *ngIf="field.fieldTypeName=='Image'">
                    <div class="customUpdate" (click)="OpentoolDetail('Image')"  id="{{field.id}}"
                    (click)="OpentoolDetailText(item,field.id)"
                    [ngStyle]="{'border': '2px solid rgb(' + field.colorCode + ')'}"
                    
                    [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                    [ngClass]="{'ng-show-required' : field.showRequiredControls}"
                   
                    >
                      <span *ngIf='field.ImageData.length==0'>
                        <mat-icon>cloud_upload</mat-icon>
                        Upload Image
                      </span>
                      <div *ngFor="let img of field.ImageData" class="uploadedData">
                        <img *ngIf='img.Imageurl' [src]="img.Imageurl" [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}"/> 
                     </div>                  
                                      
                     <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}" 
                     (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
                    </div>                   
                   </ng-container> 
         
                   
                       </div>
                     </div>
                   </div>
                  </ng-container>
        
                 
                </ng-container>
        
                    <!-- <img [src]="base64(item.img)" id="imgSrc{{i}}" alt="" (click)="onClickOutside($event)"> -->
                    <img [src]="item.img" alt="" id="imgSrc{{i}}" style="width:1000px" (click)="onClickOutside($event)">              
                   <div id="imageDrawContainer"  style="position: absolute;left: 0px; top: 0px;" *ngFor="let imgDrawn of item.drawings" [innerHtml]="imgDrawn">
                     
                   </div>
            </div>
            </div>
                
            </div>
          
            <mat-card class="rblockPanel" *ngIf="isPageLoaded" [ngClass]="{'open' : showFiles}">
                <div class="allpages" *ngFor="let p of pjtDocumentImgThumbs">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header >
                        <mat-panel-title>
                          {{p.documentName}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
            
                      <div class="page" *ngFor="let pg of p.images;let i = index" (click)='scrollToPage(i+1)'>
                        <span>{{i+1}}</span>
                        <img
                          [src]="pg.pageImageUrl"
                          alt=""
                        />
                      </div>
                    </mat-expansion-panel>           
                  </mat-accordion>
                </div>
        
             
              </mat-card>
              <div class="rblockOverlay" [ngClass]="{'open' : showFiles}" (click)="showAllFiles()"></div>
        
        
        </div>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>